<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <div class="my-auto mb-2">
          <h2 class="mb-1">Clients</h2>
          <nav>
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item">
                <router-link to="/dashboard/"
                  ><i class="ti ti-smart-home"></i
                ></router-link>
              </li>
              <li class="breadcrumb-item">CRM</li>
              <li class="breadcrumb-item active" aria-current="page">
                Client List
              </li>
            </ol>
          </nav>
        </div>
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/crm/clients"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
                ><i class="ti ti-list-tree"></i
              ></router-link>
              <router-link to="/crm/clients-grid" class="btn btn-icon btn-sm"
                ><i class="ti ti-layout-grid"></i
              ></router-link>
            </div>
          </div>
          <div class="me-2 mb-2">
            <button class="btn btn-white d-inline-flex align-items-center" @click="exportCsv" v-can="'Client.Export'">
              <i class="ti ti-file-type-csv me-1"></i>Export CSV
            </button>
          </div>
          <div class="mb-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="modal"
              data-bs-target="#add_client"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
              v-can="'Client.Create'"
              ><i class="ti ti-circle-plus me-2"></i>Add New Client</a
            >
          </div>
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              class=""
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Clients Info -->
      <!-- Clients Info -->
      <div class="row">
        <!-- Total Clients -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-pink-transparent border border-pink d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-users-group text-pink fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Total Clients
                    </p>
                    <h4>{{ kpis.total }}</h4>
                  </div>
                </div>
                <!-- no % for total unless you track history; keep neutral -->
                <!-- <span class="badge bg-transparent-secondary text-dark d-inline-flex align-items-center fw-normal">
            <i class="ti ti-minus me-1"></i> —
          </span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Active Clients -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-success-transparent border border-success d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-share fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Active Clients
                    </p>
                    <h4>{{ kpis.active }}</h4>
                  </div>
                </div>
                <!-- <span class="badge bg-transparent-secondary text-dark d-inline-flex align-items-center fw-normal">
            <i class="ti ti-minus me-1"></i> —
          </span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Inactive Clients -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-danger-transparent border border-danger d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-pause fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      Inactive Clients
                    </p>
                    <h4>{{ kpis.inactive }}</h4>
                  </div>
                </div>
                <!-- <span class="badge bg-transparent-secondary text-dark d-inline-flex align-items-center fw-normal">
            <i class="ti ti-minus me-1"></i> —
          </span> -->
              </div>
            </div>
          </div>
        </div>

        <!-- New Clients (last N days) -->
        <div class="col-xl-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div class="card-body">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 me-2">
                    <span
                      class="p-2 br-10 bg-info-transparent border border-info d-flex align-items-center justify-content-center"
                    >
                      <i class="ti ti-user-plus fs-18"></i>
                    </span>
                  </div>
                  <div>
                    <p class="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                      New Clients <span class="text-muted"></span>
                    </p>
                    <h4>{{ kpis.newCurr }}</h4>
                  </div>
                </div>
                <!-- <span :class="['d-inline-flex','align-items-center','fw-normal', trendBadgeClass(kpis.newPct)]">
            <i :class="['me-1', trendIcon(kpis.newPct)]"></i>
            {{ fmtPct(kpis.newPct) }}
          </span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Clients Info -->

      <!-- Clients list -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Client List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3 dq-list-toolbar"
          >
            <!-- Status filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                {{ statusLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus(null)"
                    >All</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus('Active')"
                    >Active</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setStatus('Inactive')"
                    >Inactive</a
                  >
                </li>
              </ul>
            </div>
            <!-- Sort -->
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortLabel }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('recent')"
                    >Recently Added</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_asc')"
                    >Name A → Z</a
                  >
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click="setSort('name_desc')"
                    >Name Z → A</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div
            v-can="'Client.Read'"
            class="custom-datatable-filter table-responsive"
          >
            <a-table
              class="table datatable"
              :columns="columns"
              :data-source="tableData"
              :row-selection="rowSelection"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'ClientID'">
                  <router-link
                    :to="{
                      name: 'crm.clients.details',
                      params: { id: record.id },
                    }"
                    >{{ record.ClientID }}</router-link
                  >
                </template>

                <template v-else-if="column.key === 'ClientName'">
                  <div
                    v-can="'Client.Read'"
                    class="d-flex align-items-center file-name-icon"
                  >
                    <router-link
                      :to="{
                        name: 'crm.clients.details',
                        params: { id: record.id },
                      }"
                      class="avatar avatar-md border avatar-rounded"
                    >
                      <img
                        :src="
                          record.Image ||
                          require('@/assets/img/users/user-01.jpg')
                        "
                        class="img-fluid"
                        alt="img"
                      />
                    </router-link>
                    <div class="ms-2">
                      <h6 class="fw-medium">
                        <router-link
                          :to="{
                            name: 'crm.clients.details',
                            params: { id: record.id },
                          }"
                          >{{ record.ClientName }}</router-link
                        >
                      </h6>
                      <span class="fs-12 fw-normal">{{ record.Email }}</span>
                    </div>
                  </div>
                </template>

                <template v-else-if="column.key === 'Status'">
                  <span
                    :class="[
                      'badge',
                      'badge-xs',
                      'd-inline-flex',
                      'align-items-center',
                      record.Status === 'Active'
                        ? 'badge-success'
                        : 'badge-danger',
                    ]"
                  >
                    <i class="ti ti-point-filled me-1"></i>{{ record.Status }}
                  </span>
                </template>

                <template v-else-if="column.key === 'action'">
                  <div class="action-icon d-inline-flex">
                    <router-link
                      class="me-2"
                      :to="{
                        name: 'crm.clients.details',
                        params: { id: record.id },
                      }"
                      @click.stop
                      title="View"
                      v-can="'Client.Read'"
                    >
                      <i class="ti ti-eye"></i>
                    </router-link>

                    <a
                      href="javascript:void(0);"
                      class="me-2"
                      data-bs-toggle="modal"
                      data-bs-target="#add_client"
                      @click="openEdit(record)"
                      v-can="'Client.Edit'"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_client"
                      @click.stop.prevent="openDeleteModal(record)"
                      v-can="'Client.Delete'"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>

      <!-- /Clients list -->

      <div
        class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
      >
        <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
        <p>
          Powered by
          <a href="javascript:void(0);" class="text-primary"
            >DoneQuick Technological World</a
          >
        </p>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  <ClientsModal
    ref="modalRef"
    :client="editing"
    :next-code="nextClientCode"
    @refresh="reload"
  />
</template>
<script setup>
import { computed, onMounted, ref } from "vue";
import { useCrmClientStore } from "@/stores/crmClientStore";
import { storeToRefs } from "pinia";
import ClientsModal from "@/components/modal/clients-list-modal.vue";

const store = useCrmClientStore();
const { clients } = storeToRefs(store);

const columns = [
  { title: "Client ID", dataIndex: "ClientID", key: "ClientID" },
  { title: "Client Name", dataIndex: "ClientName", key: "ClientName" },
  { title: "Company Name", dataIndex: "CompanyName" },

  { title: "Phone", dataIndex: "Phone" },
  { title: "Status", dataIndex: "Status", key: "Status" },
  { title: "", key: "action" },
];

const rowSelection = { onChange() {}, onSelect() {}, onSelectAll() {} };

const filters = ref({ status: null, sort: "recent" });

const statusLabel = computed(() =>
  filters.value.status ? `Status: ${filters.value.status}` : "Select Status"
);
const sortLabel = computed(() =>
  filters.value.sort === "name_asc"
    ? "Name A → Z"
    : filters.value.sort === "name_desc"
    ? "Name Z → A"
    : "Last 7 Days"
);

function setStatus(s) {
  filters.value.status = s;
}
function setSort(s) {
  filters.value.sort = s;
}

const filtered = computed(() => {
  let rows = [...(store.clients || [])];
  if (filters.value.status)
    rows = rows.filter(
      (c) =>
        (c.status || "").toLowerCase() === filters.value.status.toLowerCase()
    );
  switch (filters.value.sort) {
    case "name_asc":
      rows.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      break;
    case "name_desc":
      rows.sort((a, b) => (b.name || "").localeCompare(a.name || ""));
      break;
    default:
      rows.sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      );
  }
  return rows;
});

const tableData = computed(() =>
  filtered.value.map((c) => ({
    _raw: c,
    id: c.id,
    key: c.id,
    ClientID: c.client_code || `CLT-${String(c.id).padStart(4, "0")}`,
    ClientName: c.name,
    CompanyName: c.company_name || c.name,
    Email: c.email,
    Phone: c.phone,
    Status: c.status || "Active",
    Image: c.logo_url,
  }))
);

// ---- Real-time KPI helpers ----
function asDate(v) {
  // tolerate null/undefined/'' and both ISO or "YYYY-MM-DD HH:mm:ss"
  if (!v) return null;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}
function pctChange(curr, prev) {
  if (prev === 0) return null; // no baseline
  return ((curr - prev) / prev) * 100;
}

// You can change this window to 7, 30, etc.
const NEW_WINDOW_DAYS = 30;

const kpis = computed(() => {
  const rows = store.clients || [];

  // counts by status
  const total = rows.length;
  const active = rows.filter(
    (c) => (c.status || "").toLowerCase() === "active"
  ).length;
  const inactive = rows.filter(
    (c) => (c.status || "").toLowerCase() === "inactive"
  ).length;

  // "new clients" = created_at within last N days
  const now = new Date();
  const startCurr = new Date(now);
  startCurr.setDate(now.getDate() - NEW_WINDOW_DAYS);

  const startPrev = new Date(now);
  startPrev.setDate(now.getDate() - 2 * NEW_WINDOW_DAYS);

  const endPrev = new Date(now);
  endPrev.setDate(now.getDate() - NEW_WINDOW_DAYS);

  const createdInRange = (d, from, to) => {
    const dt = asDate(d);
    return dt && dt >= from && dt < to;
  };

  const newCurr = rows.filter((c) =>
    createdInRange(c.created_at || c.createdAt, startCurr, now)
  ).length;

  const newPrev = rows.filter((c) =>
    createdInRange(c.created_at || c.createdAt, startPrev, endPrev)
  ).length;

  const newPct = pctChange(newCurr, newPrev);

  return {
    total,
    active,
    inactive,
    newCurr,
    // simple percent helpers for badges
    // total/active/inactive deltas can be added later if you track history
    newPct, // may be null if previous window = 0
  };
});

const fmtPct = (v) =>
  v == null || Number.isNaN(v) ? "—" : `${v >= 0 ? "+" : ""}${v.toFixed(2)}%`;
const trendIcon = (v) =>
  v == null
    ? "ti-minus"
    : v >= 0
    ? "ti-arrow-wave-right-up"
    : "ti-arrow-wave-right-down";
const trendBadgeClass = (v, base = "secondary") =>
  v == null
    ? `badge bg-transparent-${base} text-dark`
    : v >= 0
    ? `badge bg-transparent-primary text-primary`
    : `badge bg-transparent-danger text-danger`;

function reload() {
  store.fetchClients();
}
onMounted(reload);

function exportCsv() {
  const header = ["Client ID", "Client Name", "Company Name", "Email", "Phone", "Status"];
  const body = tableData.value.map((row) => [
    row.ClientID || "",
    row.ClientName || "",
    row.CompanyName || "",
    row.Email || "",
    row.Phone || "",
    row.Status || "",
  ]);
  const csv = [header, ...body]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `crm-clients-list-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

const nextClientCode = computed(() => {
  if (!clients.value?.length) return "CLT-0001";
  const nums = clients.value
    .map((c) => c.client_code || c.code || c.ClientID) // try common fields
    .filter(Boolean)
    .map((code) => parseInt(String(code).replace(/[^\d]/g, ""), 10))
    .filter((n) => !Number.isNaN(n));
  const next = (Math.max(...nums, 0) + 1).toString().padStart(4, "0");
  return `CLT-${next}`;
});

// modal edit
const editing = ref(null);
const modalRef = ref(null);
const toDelete = ref(null);
function openEdit(row) {
  console.log("Hello Two", row);
  editing.value = row._raw || null;
}

function openAddModal() {
  editing.value = null;
}

function openDeleteModal(row) {
  editing.value = row._raw || null;
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  .dq-list-toolbar {
    align-items: stretch !important;
  }

  .dq-list-toolbar > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-list-toolbar .dropdown,
  .dq-list-toolbar .dropdown-toggle,
  .dq-list-toolbar .form-control,
  .dq-list-toolbar .input-icon-end {
    width: 100%;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>


